import { useMemo } from 'react';
import { useCurrentRefinements, useHits } from 'react-instantsearch-hooks';
import BooleanFacet from '../components/facets/boolean';
import ColorFacet from '../components/facets/color';
import RangeFacet from '../components/facets/range';
import TermFacet from '../components/facets/term';
import { FacetProps } from '../components/facets/types';
import { FacetConfiguration } from '../types';
import usePath from 'helpers/hooks/usePath';


interface Options {
  configuration?: Record<string, FacetConfiguration>;
  ordering?: string[];
  render?: (result: { attribute: string; Component: JSX.Element }) => JSX.Element;
}

const useDynamicFacets = ({ configuration, ordering, render }: Options = {}) => {
  const path = usePath();
  const { results } = useHits();
  const { items } = useCurrentRefinements();
  const visibleItemsCount = items.length > 0 ? 9999 : 8; 

  const facetMapping = useMemo<Record<FacetConfiguration['type'], React.ComponentType<FacetProps>>>(
    () => ({
      range: RangeFacet,
      color: ColorFacet,
      term: TermFacet,
      boolean: BooleanFacet,
    }),
    [],
  );

  const dynamicFacets = useMemo(() => {
    if (!configuration) return <></>;

    const facets = Object.keys(configuration).map((attribute) => {
      const facet = configuration[attribute];
      const isEmptyFacet =
        (facet.type === 'color' || facet.type === 'term' || facet.type === 'boolean' || facet.type==='range') &&
        !results?.disjunctiveFacets?.find((f) => f.name === attribute);
      const Component = facetMapping[facet.type];
      const FinalComponent = <Component key={attribute} label={facet.label} attribute={attribute} />;

      return {
        attribute,
        Component: (
          <div key={attribute} className={isEmptyFacet ? 'hidden' : 'block'}>
            {render?.({ attribute, Component: FinalComponent }) ?? FinalComponent}
          </div>
        ),
      };
    });

    if (ordering) facets.sort((a, b) => ordering.indexOf(a.attribute) - ordering.indexOf(b.attribute));

    //return facets.map((facet) => facet.Component);
    return (path.path.includes("clark") || path.path.includes("dorf"))  ? facets.slice(0, visibleItemsCount).map((facet) => facet?.Component) : facets.map((facet) => facet?.Component) 

  }, [facetMapping, configuration, ordering, render, results?.disjunctiveFacets]);

  return dynamicFacets;
};

export default useDynamicFacets;
